export default __webpack_public_path__ + "static/media/6_bottom.8d6544ed.png";